import { render, staticRenderFns } from "./merchantRefundList.vue?vue&type=template&id=48c2fa3a&scoped=true&"
import script from "./merchantRefundList.vue?vue&type=script&lang=js&"
export * from "./merchantRefundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2fa3a",
  null
  
)

export default component.exports